import { render } from "./XL3.vue?vue&type=template&id=ea2c2aee&ts=true"
import script from "./XL3.vue?vue&type=script&lang=ts"
export * from "./XL3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__